import type { OwaDate } from "owa-datetime";
import { endOfDay, getTimezoneOffset, startOfDay } from "owa-datetime";
import { isGlobalFeatureEnabled } from "owa-feature-flags";

/**
 * Checks if the given date is a DST transition date.
 * A transition date is one where the timezone offset changes between
 * the start and end of the day (e.g., when clocks spring forward or fall back).
 */
export default function isDSTTransitionDate(date: OwaDate): boolean {
    if (!isGlobalFeatureEnabled("cal-surface-dst-view") &&
        !isGlobalFeatureEnabled("cal-surface-dst-view-v2")) {
        return false;
    }
    
    const startOfDayOffset = getTimezoneOffset(startOfDay(date));
    const endOfDayOffset = getTimezoneOffset(endOfDay(date));
    
    return startOfDayOffset !== endOfDayOffset;
}
